import { axiosService } from './axiosService';

const auth = () => axiosService.setAuth(true);

const unwrap = async (req: Promise<any>) => {
  try {
    const { data } = await req;
    return { ok: true, data: data?.data ?? data, raw: data };
  } catch (error: any) {
    const message =
      (error?.response?.data?.message) || error?.message || 'Request failed';
    return { ok: false, error: message };
  }
};

export const mockedTutorService = {
  list: (search: string, page = 1, limit = 24) =>
    unwrap(auth().get(`user/admin/mocked-tutors?search=${encodeURIComponent(search || '')}&page=${page}&limit=${limit}`)),
  setGender: (id: string, gender: 'Female' | 'Male' | 'Other') =>
    unwrap(auth().patch(`user/admin/mocked-tutors/${id}/gender`, { gender })),
  remove: (id: string) =>
    unwrap(auth().delete(`user/admin/mocked-tutors/${id}`)),
};
